import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiGatewayHelperService } from 'modules/app/services/apigateway-helper.service';
import { ProductViewHelperService } from 'modules/shared-postlogin/services/product-view-helper.service';
import { AppHelperService } from 'modules/app/services/app-helper.service';

@Injectable()
export class ContentAccessService {
  constructor(
      private http: HttpClient,
      private apiGatewayHelperService: ApiGatewayHelperService,
      private productViewHelperService: ProductViewHelperService,
      private appHelperService: AppHelperService
  ) {}

  public createRule(spaceId, classId, productCode, data, classStartDate) {
    return this.http.post(this.apiGatewayHelperService.getApiGatewayPrefixUrl() + spaceId + '/class/' + classId + '/product/' + productCode + '/create-access', { data, classStartDate });
  }

  public updateRule(spaceId, classId, productCode, ruleId, data, classStartDate, oldRuleInfo, isContextChanged = false) {
    return this.http.post(this.apiGatewayHelperService.getApiGatewayPrefixUrl() + spaceId + '/class/' + classId + '/product/' + productCode + '/update-access/' + ruleId,  {data, isContextChanged, classStartDate, oldRuleInfo });
  }

  public deleteRule(spaceId, classId, productCode, ruleId) {
    return this.http.delete(this.apiGatewayHelperService.getApiGatewayPrefixUrl() + spaceId + '/class/' + classId + '/product/' + productCode + '/delete-access/' + ruleId);
  }
  
  getCreateAccessComponents(classDetails, bundleCode, isMQASchool) {
    let createAccessComponentsArray = [];
    if(classDetails.products && classDetails.products.length > 0 && (classDetails.class.enddate >= Date.now())) {
      const bundledProducts = classDetails.bundles[bundleCode].products;
      createAccessComponentsArray = bundledProducts.filter(bundleProduct => {
        if(bundleProduct.meta && (bundleProduct.meta.visibility === "coming-soon" || bundleProduct.meta.visibility == 'false') && !isMQASchool){
          return;
        }
        const classProduct = classDetails.products.find(product => (product.productcode === bundleProduct['dls-product'].code ));
        return classProduct && !(bundleProduct && bundleProduct['meta'] && bundleProduct['meta']['visibility-options'] &&  bundleProduct['meta']['visibility-options']['hide-learning-path']);
      });
    }
    return createAccessComponentsArray;
  }
}